import { InteriorSetRequest } from "@1games-ru/region-shared/dist/backend/requests/interior";
import { useCallback } from "react";
import CreateEntityMpProvider from "@/core/data-provider/data-mp/create-entity/create-entity-mp-provider";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import toast from "@/domains/toasts/helpers/toast";

export default function useCreateInterior() {
  const createInterior = useCallback(async (data: InteriorSetRequest) => {
    try {
      const response = await CreateEntityMpProvider.setInterior(data);
      if (response instanceof RpcMpProviderSuccessResponse) {
        toast.success("Интерьер создан");
        return response.data;
      }
      console.log({ data, response });
      toast.error("Ошибка создания интерьера");
      return false;
    } catch (e) {
      console.log(e);
      toast.error("Ошибка создания интерьера");
      return false;
    }
  }, []);

  return {
    createInterior,
  };
}
